// Core
import React from 'react';

// Components
import { CameraFeed, LiveStatus } from '../../../../../../components/CameraFeed';

// View
import { CameraContainer } from './Camera.style';
import { CameraProps } from './Camera.types';

function Camera({
  className,
  gpsEnabled,
  isOpen,
  onOpen,
  polygons,
  running,
  testId,
  title,
  unitCoordinates,
}: CameraProps): JSX.Element {
  return (
    <CameraContainer
      data-testid={testId}
      className={className}
    >
      <CameraFeed
        title={title}
        live={running ? LiveStatus.on : LiveStatus.off}
        testId="camera-element"
        polygons={polygons}
        unitCoordinates={unitCoordinates}
        gpsEnabled={gpsEnabled}
        isOpen={isOpen}
        onOpen={onOpen}
      />
    </CameraContainer>
  );
}

export { Camera };
